import React from 'react'
import { sortColumnValues } from '../utils'

import { ExpandableCell } from './ExpandableCell'

type Analyst = {
  firstName: string
  lastName: string
}

export type AnalystCellProps = {
  analysts: Analyst[]
}

/**
 * Return true if `value` matches any name in the `analysts` list. Returns true
 * if it matches the name in either "Lastname, Firstname" or
 * "Firstname Lastname" format
 */
export const analystFilter = (value: string, analysts: Analyst[]) => {
  const filter = value.toLowerCase()
  return analysts.some(({ firstName, lastName }) => {
    const commaFormat = `${lastName.toLowerCase()}, ${firstName.toLowerCase()}`
    const nameFormat = `${firstName.toLowerCase()} ${lastName.toLowerCase()}`
    return commaFormat.includes(filter) || nameFormat.includes(filter)
  })
}

export const analystSort = (a: Analyst[], b: Analyst[]) => {
  const aa = a[0]
  const bb = b[0]
  if (!aa) return -1
  if (!bb) return 1
  return sortColumnValues(aa.lastName, bb.lastName)
}

export const AnalystCell = ({ analysts }: AnalystCellProps) => {
  if (!analysts) return null
  const analystNames = analysts.map(
    ({ firstName, lastName }) => `${lastName}, ${firstName}`
  )
  return <ExpandableCell defaultLength={5} items={analystNames} />
}
